import React from "react";
import Avatar from "@material-ui/core/Avatar";

const tabConfig = [
  {
    columnTitle: "",
    dataField: ["component"],
    component: ({ values }) => {
      return <Avatar src={values.backgroundImageURL} variant="rounded" />;
    },
  },
  {
    columnTitle: "Name",
    dataField: ["habitName"],
  },

  {
    columnTitle: "Description",
    dataField: ["habitDescription"],
  },
];

export default tabConfig;
